import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getJurisdictions() {
  try {
    const res = await tryCache('getJurisdictions', () => apiClient.get('/getJurisdictions'));

    return res;
  } catch (error) {
    console.error('getJurisdictions failed.', error);
  }
}
